
import Button from "../../components/buttons/Button.vue";
import Input from "../../components/form/Input.vue";
import Modal from "../../components/Modal.vue";
import { loginAnimation } from "../../animations/loginAnimation";
import { onMounted, defineComponent, watch } from "vue";
import { useRouter } from "vue-router";
import { useField, useForm } from "vee-validate";
import { loginSchema } from "../../utils/validationSchemas";
import { useUser, LoginData } from "../../utils/composable/useUser";

export default defineComponent({
  components: {
    Button,
    Input,
    Modal,
  },
  setup() {
    const router = useRouter();

    const { handleSubmit, errors } = useForm({
      validationSchema: loginSchema,
    });

    const { value: email } = useField("email");
    const { value: password } = useField("password");

    const { isLoggedIn, login, checkLoginStatus } = useUser();

    const handleLogin = handleSubmit((data, { resetForm }) => {
      resetForm();

      return login(data as LoginData);
    });

    onMounted(() => {
      loginAnimation();
    });

    checkLoginStatus();

    watch(
      () => isLoggedIn.value,
      () => {
        if (isLoggedIn.value) {
          router.push({ path: "/panel/start" });
        }
      },
    );

    return { errors, handleLogin, email, password };
  },
});
